import { lazy, ReactNode, Suspense } from "react";
import Navigation from "@/components/Navigation";
import { DeferredAppMount } from "@/components/DeferredAppMount";

const PublicMaintenanceRedirect = lazy(() =>
  import("@/components/PublicMaintenanceRedirect").then((module) => ({
    default: module.PublicMaintenanceRedirect,
  }))
);

// QueryClient + ComparisonProvider now live in the app-level shell (App.tsx), so
// public routes share one stable cache and never remount their providers.
// Navigation is rendered here ONCE (this layout element stays mounted across all
// public-route navigations), so the header no longer remounts/flickers on each
// link click — pages must not render their own <Navigation />.
export const PublicRouteShell = ({ children }: { children: ReactNode }) => {
  return (
  <>
    <Navigation />
    <Suspense fallback={<div className="min-h-screen bg-surface" aria-hidden="true" />}>
      {children}
    </Suspense>
    <DeferredAppMount delay={2500} timeout={4000}>
      <Suspense fallback={null}>
        <PublicMaintenanceRedirect />
      </Suspense>
    </DeferredAppMount>
  </>
  );
};

export default PublicRouteShell;
